import styles from './ChatPane.module.css';

const TOOL_LABELS = {
  'mcp__portfolio-tools__list_channels': 'Listing channels...',
  'mcp__portfolio-tools__get_channel_blocks': 'Reading blocks...',
  'mcp__portfolio-tools__search_blocks': 'Searching blocks...',
  'mcp__portfolio-tools__list_frameworks': 'Browsing frameworks...',
  'mcp__portfolio-tools__get_framework': 'Reading framework...',
  'mcp__portfolio-tools__create_block': 'Creating block...',
  'mcp__portfolio-tools__create_channel': 'Creating channel...',
};

export default function ChatMessage({ message }) {
  if (message.type === 'fork_indicator') {
    return (
      <div className={styles.forkIndicator}>
        forked from previous conversation
      </div>
    );
  }

  const isUser = message.role === 'user';
  const isVoice = message.source === 'voice';

  return (
    <div className={`${styles.message} ${isUser ? styles.userMessage : styles.assistantMessage}`}>
      {!isUser && message.toolCall && (
        <div className={styles.toolIndicator}>
          {TOOL_LABELS[message.toolCall] || 'Thinking...'}
        </div>
      )}
      <div className={styles.messageContent}>
        {isVoice && (
          <svg className={styles.voiceBadge} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" title="Voice message">
            <rect x="6" y="1" width="4" height="8" rx="2" />
            <path d="M3.5 7a4.5 4.5 0 0 0 9 0" />
            <line x1="8" y1="11.5" x2="8" y2="14" />
            <line x1="5.5" y1="14" x2="10.5" y2="14" />
          </svg>
        )}
        {message.content}
        {message.streaming && !message.content && (
          <span className={styles.cursor} />
        )}
      </div>
    </div>
  );
}
